import { PublicWhitePaperType } from '@utils/types'

const getPublicWhitePaperTypeDisplayString = (publicWhitePaperType: string) => {
  const POST_TYPE_LOOKUP = {
    [PublicWhitePaperType.IT_CUSTOMER]: 'Tech Customer',
    [PublicWhitePaperType.TECH_VENDOR]: 'Tech Vendor',
  }

  return POST_TYPE_LOOKUP[publicWhitePaperType as PublicWhitePaperType]
}

export default {
  getPublicWhitePaperTypeDisplayString,
}
